var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "#0E8F3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01429 8.86851L4.28039 7.13462C4.10187 6.95609 3.81242 6.95609 3.63389 7.13462C3.45537 7.31314 3.45537 7.60259 3.63389 7.78112L5.69104 9.83826C5.86956 10.0168 6.15901 10.0168 6.33753 9.83826L11.3661 4.80969C11.5446 4.63116 11.5446 4.34172 11.3661 4.16319C11.1876 3.98467 10.8981 3.98467 10.7196 4.16319L6.01429 8.86851Z",
    fill: "#0E8F3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBg);
export default __webpack_public_path__ + "static/media/success-bg.2fd6474870aa31eb671b5e5e56595e82.svg";
export { ForwardRef as ReactComponent };